import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { IconButton, Tooltip, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import RoomContext from "../../context/RoomContext";
import {
  ROOM_MINI_TOGGLE_RESERVE_MINI_PX,
  ROOM_MINI_TOGGLE_RESERVE_PX,
  useConversationMiniToggleVisible,
} from "../../helpers/remoteControl/roomChrome";

const useStyles = makeStyles(() => ({
  root: {
    position: "absolute",
    top: 10,
    right: 10,
    zIndex: 40,
    padding: 4,
    borderRadius: 10,
    background: "rgba(24, 28, 30, 0.72)",
    backdropFilter: "blur(6px)",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.18)",
  },
  rootReserveMiniToggle: {
    right: ROOM_MINI_TOGGLE_RESERVE_PX,
  },
  miniRoot: {
    top: 6,
    right: 6,
  },
  miniRootReserveMiniToggle: {
    right: ROOM_MINI_TOGGLE_RESERVE_MINI_PX,
  },
  button: {
    color: "#ffb4b4",
    padding: 6,
    "&:hover": {
      background: "rgba(227, 59, 74, 0.18)",
    },
  },
  miniButton: {
    padding: 4,
  },
}));

const RemoteControlHostActions = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { roomClient } = useContext(RoomContext);
  const meId = useSelector((state) => state.me.id);
  const isMini = useSelector((state) => state.call.displayMini);
  const reserveMiniToggle = useConversationMiniToggleVisible();
  const session = useSelector((state) => state.remoteControl);

  if (
    !session ||
    session.status !== "active" ||
    session.hostPeerId !== meId
  ) {
    return null;
  }

  const label = intl.formatMessage({
    id: "remoteControl.reclaim",
    defaultMessage: "Take back control",
  });

  const rootClass = [
    classes.root,
    isMini ? classes.miniRoot : null,
    reserveMiniToggle
      ? isMini
        ? classes.miniRootReserveMiniToggle
        : classes.rootReserveMiniToggle
      : null,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass}>
      <Tooltip title={label}>
        <IconButton
          size="small"
          className={`${classes.button} ${isMini ? classes.miniButton : ""}`}
          aria-label={label}
          onClick={() => roomClient.endRemoteControl()}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default RemoteControlHostActions;
